<section
  aria-labelledby="landing-hero-title"
  class="flex w-full flex-col justify-center overflow-hidden bg-transparent px-4 pt-12 sm:pb-20 sm:px-6 lg:min-h-[761px] lg:px-10 lg:pt-0 lg:pb-0"
>
  <div class="mx-auto w-full max-w-350">
    <div
      class="flex w-full flex-col gap-12 lg:grid lg:min-h-[761px] lg:grid-cols-[minmax(0,914px)_486px] lg:gap-0"
    >
      <div
        class="flex w-full flex-col justify-center lg:min-h-[661px] lg:justify-end lg:pt-7 lg:pb-32"
      >
        <h1
          id="landing-hero-title"
          class="mb-8 max-w-[567px] text-[44px] font-bold leading-[1.1] tracking-[0.005em] text-white sm:text-[52px] lg:mb-10 lg:text-[60px] lg:leading-[73px]"
        >
          {{ heading() }}
        </h1>

        <div
          class="mb-10 max-w-[784px] text-[24px] font-medium leading-[30px] tracking-[0.005em] text-white lg:text-[30px] lg:leading-[36px]"
        >
          <p>
            @for (segment of leadSegments(); track $index) {
              <span [class.text-accent]="segment.accent">{{ segment.text }}</span>
            }
          </p>

          <p class="mt-8 text-[24px] font-light leading-[29px]">{{ bodyText() }}</p>
        </div>

        @if (primaryAction() || secondaryAction()) {
          <div class="flex sm:h-auto sm:flex-wrap sm:items-center sm:gap-4 lg:h-[62px]">
            @if (primaryAction(); as action) {
              @if (action.register) {
                <button
                  type="button"
                  class="btn-primary h-[62px] w-full max-w-[207px] px-5 py-[22px] text-[15px] font-semibold leading-[18px]"
                  (click)="signUp()"
                  data-ph-capture-attribute-sc-event="registration started"
                >
                  {{ action.label }}
                  <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
                </button>
              } @else if (action.routerLink; as routerLink) {
                <a
                  class="btn-primary h-[62px] w-full max-w-[207px] px-5 py-[22px] text-[15px] font-semibold leading-[18px]"
                  [routerLink]="routerLink"
                >
                  {{ action.label }}
                  <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
                </a>
              } @else if (action.href; as href) {
                <a
                  class="btn-primary h-[62px] w-full max-w-[207px] px-5 py-[22px] text-[15px] font-semibold leading-[18px]"
                  [href]="href"
                >
                  {{ action.label }}
                  <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
                </a>
              } @else {
                <span
                  class="btn-primary pointer-events-none h-[62px] w-full max-w-[207px] select-none px-5 py-[22px] text-[15px] font-semibold leading-[18px]"
                >
                  {{ action.label }}
                  <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
                </span>
              }
            }

            @if (secondaryAction(); as action) {
              @if (action.register) {
                <button
                  type="button"
                  class="btn-without-outline h-[62px] w-full max-w-[273px] px-5 py-[22px] text-[15px] font-semibold leading-[18px]"
                  (click)="signUp()"
                  data-ph-capture-attribute-sc-event="registration started"
                >
                  {{ action.label }}
                  <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
                </button>
              } @else if (action.routerLink; as routerLink) {
                <a
                  class="btn-without-outline h-[62px] w-full max-w-[273px] px-5 py-[22px] text-[15px] font-semibold leading-[18px]"
                  [routerLink]="routerLink"
                >
                  {{ action.label }}
                  <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
                </a>
              } @else if (action.href; as href) {
                <a
                  class="btn-without-outline h-[62px] w-full max-w-[273px] px-5 py-[22px] text-[15px] font-semibold leading-[18px]"
                  [href]="href"
                >
                  {{ action.label }}
                  <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
                </a>
              } @else {
                <span
                  class="btn-without-outline h-[62px] w-full max-w-[273px] select-none px-5 py-[22px] text-[15px] font-semibold leading-[18px]"
                >
                  {{ action.label }}
                  <lucide-icon name="chevron-right" [size]="14"></lucide-icon>
                </span>
              }
            }
          </div>
        }
      </div>

      <div class="flex items-center justify-center lg:justify-start">
        <div
          class="relative isolate aspect-486/740 w-full max-w-64 sm:max-w-72 md:max-w-104 lg:h-[740px] lg:max-w-none xl:w-[486px]"
        >
          <div
            aria-hidden="true"
            class="absolute left-[11%] top-[12%] z-0 h-[59%] w-[88%] rounded-[1000px]"
            style="background-color: #06263a"
          ></div>
          <img
            [ngSrc]="imagePath()"
            [alt]="imageAlt()"
            width="600"
            height="942"
            priority
            class="absolute left-[14%] top-[2%] z-10 h-auto w-[83%] rotate-[5.7deg] drop-shadow-2xl"
          />
        </div>
      </div>
    </div>
  </div>
</section>
